// import React from 'react';
import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import Layout from "./Layout";
import HomeIcon from "../assets/icons/home_icon";
import Logo from "../images/bentex-logo.png";
import axios from "axios";
import config from "../config";
import productStyleAttributes from "../utils/productStyleAttributes";
import productMeasurements from "../utils/productMeasurements";
import { jsPDF } from "jspdf"; // Import jsPDF
import html2pdf from "html2pdf.js"; // Import html2pdf.js
import html2canvas from "html2canvas";
import { PDFDocument, rgb } from "pdf-lib";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ClipLoader from "react-spinners/ClipLoader";

const OrderPreview = () => {
  const { order_id } = useParams();
  const [orderData, setOrderData] = useState();
  const [orderProducts, setOrderProducts] = useState([]);
  const [customer, setCustomer] = useState("");
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  
  const fetchOrdrDetails = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${config.BASE_URL}/api/v1/orderDetail/${order_id}`
      );
      setOrderData(response.data?.orderDetail);
      setCustomer(response.data?.orderDetail?.customer_id);
      setOrderProducts(response.data?.productDetail);
    } catch (error) {
      console.error("Error fetching quote details:", error);
    } finally {
      setLoading(false);
    }
  };
  function formatDate(isoDate) {
    if (isoDate) {
      const date = new Date(isoDate);
      return date.toLocaleDateString("en-GB");
    } else {
      return "";
    }
  }


  const formatImageUrl = (url) => {
    if (!url) return "";
    if (url.startsWith("https://firebasestorage")) {
      return url; // Firebase direct
    }
    return `${config.BASE_URL}/${url}`; // Local files
  };


  const handleGeneratePDF = async () => {
    setLoading(true);

    const options = {
      scale: 2,
      useCORS: true,
    };

    const pdf = new jsPDF("p", "mm", "a4");
    const pageHeight = 297; // A4 height in mm
    let yOffset = 2; // Initial Y position

    const elements = document.querySelectorAll(".canva_row"); // Select all content blocks

    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];

      // Convert each element to an image using html2canvas
      const canvas = await html2canvas(element, options);
      const imgData = canvas.toDataURL("image/jpeg", 1.0);

      const imgWidth = 210; // A4 width in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio

      let currentY = yOffset;

      // Split image if it exceeds A4 height
      let remainingHeight = imgHeight;

      if (i > 0) {
        pdf.addPage(); // Create a new page if the content overflows
        currentY = 10; // Reset Y position
      }

      const cropHeight = Math.min(remainingHeight, pageHeight - 10); // Max height per page
      pdf.addImage(imgData, "JPEG", 0, currentY, imgWidth, 0);

      remainingHeight -= cropHeight;
      currentY += cropHeight;
    }

    const today = new Date();
    const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
      today.getMonth() + 1
    ).padStart(2, "0")}-${today.getFullYear()}`;
    const customerName = orderData.customer_id.customer_name;

    const pdfName = `Order_${customerName}_${formattedDate}.pdf`;

    pdf.save(pdfName);
    setLoading(false);
  };

  const handleEditPDF = () => {
    navigate(`/edit-order/${order_id}`);
  };

  const handleEmail = async () => {
    try {
      setLoading(true);
      const options = {
        scale: 2,
        useCORS: true,
      };

      const pdf = new jsPDF("p", "mm", "a4");
      const pageHeight = 297; // A4 height in mm
      let yOffset = 2; // Initial Y position

      const elements = document.querySelectorAll(".canva_row"); 

      for (let i = 0; i < elements.length; i++) {
        const element = elements[i];

        // Convert each element to an image using html2canvas
        const canvas = await html2canvas(element, options);
        const imgData = canvas.toDataURL("image/jpeg", 1.0);

        const imgWidth = 210; // A4 width in mm
        const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio

        let currentY = yOffset;

        if (i > 0) {
          pdf.addPage(); // Create a new page if content overflows
          currentY = 10; // Reset Y position
        }

        pdf.addImage(imgData, "JPEG", 0, currentY, imgWidth, 0);
      }

      // Convert PDF to Blob
      const pdfBlob = pdf.output("blob");


   
      const formData = new FormData();
      formData.append("name", customer.customer_name);
      formData.append("email", customer.email);
      formData.append("subject", order_id);
      // formData.append("title", `Invoice_Order_${order_id}`);
      // formData.append("title", `Invoice_Order_${order_id}`);
      formData.append("title", `Order_No_${orderData?.order_no}`);
      formData.append("pdf", pdfBlob, "invoice.pdf");
      formData.append("type", "order");
      formData.append("location", orderData.location);
      // Send email via API
      const response = await axios.post(
        `${config.BASE_URL}/api/v1/sendEmail`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        toast.success("Email sent successfully!");
        const updateResponse = await axios.put(
          `${config.BASE_URL}/api/v1/orders/${order_id}`,
          {
            status: "Production",
          }
        );
        if (updateResponse.status === 200) {
          toast.success("Status updated to production!");
        } else {
          toast.error("Email sent, but failed to update order status.");
        }
        setLoading(false);
      } else {
        toast.error("Failed to send email. Please try again.");
      }
    } catch (error) {
      console.error("Error sending email:", error);
      toast.error(
        "Error sending email. Please check the console for more details."
      );
    }
  };



  function normalizeStyleValue(styleValue) {
    if (!styleValue) return "";
    if (typeof styleValue === "string") return styleValue;
    if (typeof styleValue === "object" && styleValue.value) return styleValue.value;
    return "";
  }




function parseStyles(styleData) {
  if (typeof styleData === 'string' && styleData) {
    try {
      return JSON.parse(styleData);
    } catch (e) {
      return {}; // Return empty on error
    }
  } else if (typeof styleData === 'object' && styleData !== null) {
    return styleData; 
  }
  return {}; 
}



function renderStylesData(style, type = "default") {
  const styleObject = parseStyles(style);
  if (!styleObject || typeof styleObject !== "object") return null;

  // 1. Prepare Keys
  const order = STYLE_ORDER_BY_TYPE[type] ?? [];
  const styleKeys = Object.keys(styleObject);
  const lowerToOriginal = {};
  styleKeys.forEach((k) => {
    lowerToOriginal[k.toLowerCase()] = k;
  });

  // 2. Merge Order: Start with defined order, append anything else found in data
  const allKeysToRender = [...order];
  const lowerOrderSet = new Set(order.map((k) => k.toLowerCase()));

  styleKeys.forEach((k) => {
    if (!lowerOrderSet.has(k.toLowerCase())) {
      allKeysToRender.push(k); // Add unknown keys to the end
    }
  });

  // 3. Render
  return allKeysToRender.map((key) => {
    if (key === "remarks") return null; // Skip remarks (handled separately)

    // Find value handling case sensitivity
    const lowerReq = key.toLowerCase();
    const originalDataKey = lowerToOriginal[lowerReq]; 
    
    let rawValue = "";
    if (originalDataKey) {
      rawValue = styleObject[originalDataKey];
    }

    const styleValue = normalizeStyleValue(rawValue);

    // Get Label Definitions
   
    const styleAttr = productStyleAttributes(key,type);
    let labelObj = { 
  en: formatCamelCaseLabel(key), 
  th: "" 
};

    let imgUrl = null;

    if (styleAttr) {
      // Complex Object Match
      const matchedKey =
        typeof styleAttr === "object" && !styleAttr.label
          ? Object.keys(styleAttr).find(
              (k) => k.toLowerCase() === String(styleValue).toLowerCase()
            )
          : null;

      if (matchedKey) {
        labelObj = styleAttr[matchedKey]?.label || labelObj;
        if (styleAttr[matchedKey]?.showImage) imgUrl = styleAttr[matchedKey].img;
      } else if (styleAttr.label) {
        // Simple Object Match
        labelObj = styleAttr.label;
        if (styleAttr.showImage) imgUrl = styleAttr.img;
      }
    }

    return (
      <div className="col-review col-5" key={key}>
        <div className="title" style={{ 
            wordWrap: "break-word",       
            overflowWrap: "break-word",   
            whiteSpace: "normal",         
            width: "100%",                
            overflow: "hidden"            
          }}><b>{labelObj.en} {labelObj.th ? `| ${labelObj.th}` : ""}
          </b>
        </div>
        
        {/* Always show value or dash */}
        <div className="value" style={{ minHeight: "20px" }}>
          {styleValue || "-"}
        </div>

        {imgUrl && (
          <div className="styleImg">
            <img src={imgUrl} alt={key} />
          </div>
        )}
      </div>
    );
  });
}
  const MEASUREMENT_ORDER_BY_TYPE = {
    Jacket: [
      "sex",
      "measurement",
      "frontLength",
      "firstButton",
      "chest",
      "waistUpper",
      "waistLower",
      "hips",
      "shoulders",
      "sleevesRight",
      "sleevesLeft",
      "neck",
      "ptpFront",
      "ptpBack",
      "armHole",
      "biceps",
      "forearm",
      "wristLeft",
      "wristRight",
      "shoulder",
      "waist",
      "chestDrop",
      "tuxRemarks", 
    ],
    Pant: [
      "sex",
      "pantWaist",
      "hips",
      "crotchHigh",
      "crotchLow",
      "inseamLength",
      "thighs",
      "knees",
      "calf",
      "cuffsAnkle",
      "lengthOutleg",
      "pantRemarks",
    ],
    Shirt: [
      "sex",
      "measurement",
      "frontLength",
      "firstButton",
      "chest",
      "waistUpper",
      "waistLower",
      "hips",
      "shoulders",
      "sleevesRight",
      "sleevesLeft",
      "neck",
      "ptpFront",
      "ptpBack",
      "armHole",
      "biceps",
      "forearm",
      "wristLeft",
      "wristRight",
      "shoulder",
      "waist",
      "chestDrop",
      "tuxRemarks",
    ],
    Tuxedo: [
      "sex",
      "fit",
      "jacketMeasurement",
      "frontJacketLength",
      "firstButton",
      "chest",
      "waistUpper",
      "waistLower",
      "hips",
      "shoulders",
      "sleevesRight",
      "sleevesLeft",
      "neck",
      "ptpFront",
      "ptpBack",
      "armHole",
      "biceps",
      "forearm",
      "wristLeft",
      "wristRight",
      "shoulder",
      "waist",
      "chestDrop",
      "tuxRemarks",
    ],
    Vest: [
      "sex",
      "measurement",
      "frontLength",
      "backVestLength",
      "chest",
      "waistUpper",
      "waistLower",
      "hipsVest",
      "shoulders",
      "sleevesRight",
      "sleevesLeft",
      "neck",
      "ptpFront",
      "ptpBack",
      "armHole",
      "biceps",
      "forearm",
      "wristLeft",
      "wristRight",
      "shoulder",
      "waist",
      "chestDrop",
      "tuxRemarks",
    ],
    Overcoat: [
      "sex",
      "fit",
      "jacketMeasurement",
      "frontJacketLength",
      "backJacketLength",
      "chest",
      "waistUpper",
      "waistLower",
      "hips",
      "shoulders",
      "sleevesRight",
      "sleevesLeft",
      "neck",
      "ptpFront",
      "ptpBack",
      "armHole",
      "biceps",
      "wristLeft",
      "wristRight",
      "shoulder",
      "waist",
      "chestDrop",
      "tuxRemarks",
    ],

  };

  const OVERRIDE_KEY_MAP = {
  // -------- Basic Fields --------
  "sex": "sex",
  "measurement": "measurement",
  "fit": "fit",
  "Style Remarks": "remarks",
  "measurement remarks": "tuxRemarks",
  "measurement remarks": "remarks",
  "jacket remarks": "remarks",

  // -------- Chest --------
  "chest": "chest",
  "chestDrop": "chestDrop",

  // -------- Front Length --------
  "front length": "frontLength",
  "front jacket length": "frontJacketLength",
  "front jacket length": "frontJacketLength",

  // -------- Back Length --------
  "back length": "backLength",
  "back jacket length": "backJacketLength",

  // -------- First Button --------
  "first button": "firstButton",
  "1st button": "firstButton",

  // -------- Waist --------
  "waist": "waist",
  "waist upper": "waistUpper",
  "waist lower": "waistLower",

  // -------- Hips --------
  "hips": "hips",

  // -------- Shoulders --------
  "shoulders": "shoulders",
  "shoulder": "shoulder",

  // -------- Sleeves --------
  "sleeves right": "sleevesRight",
  "sleeves left": "sleevesLeft",

  // -------- Neck --------
  "neck": "neck",

  // -------- PTP --------
  "ptp front": "ptpFront",
  "ptp - front": "ptpFront",
  "ptp back": "ptpBack",
  "ptp - back": "ptpBack",

  // -------- Arm Hole --------
  "arm hole": "armHole",
  "armhole": "armHole",

  // -------- Biceps --------
  "biceps": "biceps",

  // -------- Forearm --------
  "forearm": "forearm",

  // -------- Wrist --------
  "wrist left": "wristLeft",
  "wrist right": "wristRight",

  // -------- Pant Fields --------
  "crotch high": "crotchHigh",
  "crotch low": "crotchLow",
  "inseam length": "inseamLength",
  "thighs": "thighs",
  "knees": "knees",
  "calf": "calf",
  "cuffs": "cuffsAnkle",
  "length (outleg)": "lengthOutleg",
  "outleg length": "outlegLength",
  "Measurement Remarks":"pantRemarks",

  // -------- Vest Fields --------
  "vest hip": "vestHip",

  // -------- Overcoat / Tuxedo --------
  "front jacketlength": "frontJacketLength",
  "back jacketlength": "backJacketLength",
   "measurement remarks": "coatRemarks",
};

function toCamelCaseKey(label) {
  if (!label || typeof label !== "string") return label || "";
  const lower = label.trim().toLowerCase();
  if (OVERRIDE_KEY_MAP[lower]) return OVERRIDE_KEY_MAP[lower];

  // remove parentheses content, punctuation, keep spaces
  const cleaned = lower.replace(/\(.*?\)/g, "").replace(/[^a-z0-9\s]/g, " ").trim();
  const parts = cleaned.split(/\s+/).filter(Boolean);
  if (parts.length === 0) return cleaned;
  return parts.map((p, i) => (i === 0 ? p : p[0].toUpperCase() + p.slice(1))).join("");
}




function renderMeasurementsData(measurement = {}, type = "default") {
  if (!measurement || typeof measurement !== "object") return null;

  // 1. Get all actual keys from the data
  const dataKeys = Object.keys(measurement);
  const lowerToOriginal = {};
  dataKeys.forEach((k) => {
    lowerToOriginal[k.toLowerCase()] = k;
  });

  // 2. Get the Preferred Order
  const order = MEASUREMENT_ORDER_BY_TYPE[type] ?? [];
  const processedKeys = new Set(); // Keep track of what we have rendered

  // --- PART A: Render fields based on Defined Order ---
  const orderedRender = order.map((reqKey) => {
    const lowerReq = reqKey.toLowerCase();
    let matchingKey = null;

    // Try to find a match in data
    if (lowerToOriginal[lowerReq]) {
      matchingKey = lowerToOriginal[lowerReq];
    } else {
      // Try normalization logic
      const alt = toCamelCaseKey(reqKey);
      if (alt && lowerToOriginal[alt.toLowerCase()]) {
        matchingKey = lowerToOriginal[alt.toLowerCase()];
      } else {
        // Reverse check
        for (const orig of dataKeys) {
          const normOrig = toCamelCaseKey(orig).toLowerCase();
          if (normOrig === lowerReq) {
            matchingKey = orig;
            break;
          }
        }
      }
    }

    // If found, add to processed list
    if (matchingKey) processedKeys.add(matchingKey);

    // Get Value
    const rawVal = matchingKey ? measurement[matchingKey] : undefined;
    let display = "";

    if (rawVal !== undefined && rawVal !== "" && rawVal !== null) {
      display =
        typeof rawVal === "object" && rawVal !== null && "value" in rawVal
          ? rawVal.value
          : rawVal;
    }

    // Get Label
    let labels = productMeasurements(reqKey);
    if (!labels) labels = productMeasurements(toCamelCaseKey(reqKey));
    if (!labels) labels = { en: reqKey, th: "" };

    return (
      <div className="row-review" key={`ordered-${reqKey}`}>
        <div className="measurement">
          <label className="measurement" style={{maxWidth:'150px'}}>
            {labels.en} {labels.th ? `| ${labels.th}` : ""}:
          </label>
        </div>
        <div className="value">{display || "-"}</div>
      </div>
    );
  });

  // --- CONDITIONAL CHECK ---
  // If the product is Jacket or Pant, strictly follow the order and STOP here.
  if (type === "Jacket" || type === "Pant") {
    return orderedRender;
  }

  // --- PART B: Render Remaining/Unknown keys (For other types like Shirt, etc.) ---
  // const remainingRender = dataKeys.map((key) => {
  //   // If we already rendered this key in Part A, skip it
  //   if (processedKeys.has(key)) return null;

  //   // Skip specific system keys
  //   if (key === "remarks" || key === "tuxRemarks") return null;

  //   const rawVal = measurement[key];
  //   let display = "";

  //   if (rawVal !== undefined && rawVal !== "" && rawVal !== null) {
  //     display =
  //       typeof rawVal === "object" && rawVal !== null && "value" in rawVal
  //         ? rawVal.value
  //         : rawVal;
  //   }

  //   return (
  //     <div className="row-review" key={`extra-${key}`}>
  //       <div className="measurement">
  //         <label className="measurement">{key}:</label>
  //       </div>
  //       <div className="value">{display || "-"}</div>
  //     </div>
  //   );
  // });

  return [...orderedRender];
}

function formatCamelCaseLabel(str = "") {
  return str
    .replace(/([A-Z])/g, " $1") // Insert space before capital letters
    .replace(/^./, (c) => c.toUpperCase()) // Capitalize first letter
    .trim(); // Clean spaces
}
const STYLE_ORDER_BY_TYPE = {
  Jacket: [
    "jacket_style",
    "btnStyle",
    "lapelStyle",
    "lapelwidth",
    "lapelBoutonniere",
    "hipPocket",
    "chestPocket",
    "vent",
    "Lining",
    "suitButtons",
    "sleeveButton",
    "sleeveButtonType",
    "sleeveButtonholeThread",
    "pickEdgeStitching",
    "collorFelt",
    "monogramTextType",
    "monogramTextColor",
    "monogramText1",
    "monogramText2",
    "fit",
    "remarks",
  ],
  Pant: [
    "frontPleat",
    "waistbandStyle",
    "frontPocket",
    "numberOfBackPockets",
    "backPocket",
    "cuff",
    "buttons",
    "suspenderButtons",
    "fit",
    "bandEdgeSystem",
    "waistBandWidth",
    "btnHoleColor",
    "btnThreadColor",
    "flyOption",
    "coinPocket",
    "internalWBandColor",
    "tuxedoSatin",
    "remarks",
  ],
  Tuxedo: [
    "jacket_style",
    "btnStyle",
    "lapelStyle",
    "lapelwidth",
    "lapelBoutonniere",
    "hipPocket",
    "chestPocket",
    "vent",
    "Lining",
    "stinStyle",
    "satinColour",
    "suitButtons",
    "sleeveButton",
    "sleeveButtonType",
    "sleeveButtonholeThread",
    "pickEdgeStitching",
    "collorFelt",
    "monogramTextType",
    "monogramTextColor",
    "monogramText1",
    "monogramText2",
    "fit",
    "remarks",
  ],
  Shirt: [
    "shirtColorStyle",
    "CollarStay",
    "CollarstyleButtonOption",
    "shirtCuffStyle",
    "shirtPlacketStyle",
    "YokeStyle",
    "shirtBackStyle",
    "Tuxedoshirt",
    "shirtBottomStyle",
    "pocket",
    "PocketStyle",
    "shirtButtons",
    "Buttonholecolour",
    "ThreadOnButton",
    "ContrastFabricOptions",
    "fit",
    "monogramTextType",
    "monogramTextColor",
    "monogramPosition",
    "monogramText",
    "remarks",
  ],
  Vest: [
    "vestStyle",
    "btnStyle",
    "lapelStyle",
    "chestPocket",
    "bottomPocket",
    "bottomOfVest",
    "LiningAtBack",
    "vestButton",
    "buttonNumber",
    "fit",
    "remarks",
  ],
  Overcoat: [
    "coatStyle",
    "btnStyleMultiple",
    "lapelStyle",
    "lapelwidth",
    "lapelBoutonniere",
    "lapelFelt",
    "elBowPatch",
    
    "chestPocket",
    "hipPocket",
    "vent",
    "suitButtons",
     "apaulettes",
    "sleeveDetail",
    "sleeveButton",
    "sleeveButtonType",
    "sleeveBtnHoleColor",
   
    "jacketButtons",
    "buttonholeThread",
    "belt",
    "Lining",
    "pickEdgeStitching",
    "collorFelt",
    "monogramTextType",
    "monogramTextColor",
    "monogramText",
    "fit",
    "remarks",
  ],
};


  function renderProductBlock(item, key) {
    // --- THIS BLOCK WAS ADDED ---
    let parsedStyles = item?.styles; // Assume it's an object
    
    if (typeof parsedStyles === 'string' && parsedStyles) {
      // If it's a string, try to parse it
      try {
        parsedStyles = JSON.parse(parsedStyles);
      } catch (e) {
        console.error("Failed to parse styles in renderProductBlock:", e, parsedStyles);
        parsedStyles = {}; // Set to empty object on error
      }
    } else if (typeof parsedStyles !== 'object' || !parsedStyles) {
      parsedStyles = {}; // Set to empty object if null/undefined
    }

    return (
      <div className="canva_row break-page" key={key}>
        <div className="border-blk">
          <div className="row">
            <div className="col-sm-3">
              <img src={Logo} alt="" />
            </div>
            <div className="col-sm-6">
              <div className="m-b-0 row">
                <label className="col-md-6 order-lable">Customer Name / ชื่อลูกค้า</label>
                <label className="col-md-6 order-field">
              {item.customerName || item?.customer_id?.customer_name || orderData?.customer_id?.customer_name}
            </label>
              </div>
              <div className="m-b-0 row">
                <label className="col-sm-6 order-lable">Order No / ใบสั่งซื้อ</label>
                <label className="col-sm-6 order-field">{orderData?.order_no} / {item?.description}</label>
              </div>
              <div className="m-b-0 row">
                <label className="col-sm-6 order-lable">Fabric No / เบอร์ผ้า</label>
                <label className="col-sm-6 order-field">{item?.fabric}</label>
              </div>
              <div className="m-b-0 row">
                <label className="col-sm-6 order-lable">Lining No / เบอร์ผ้าซับใน</label>
                <label className="col-sm-6 order-field">{item?.lining}</label>
              </div>
              <div className="m-b-0 row">
                <label className="col-sm-6 order-lable">Qty / จํานวน</label>
                <label className="col-sm-6 order-field">{item?.quantity}</label>
              </div>
              {orderData?.team_member && <div className="m-b-0 row">
                <label className="col-sm-6 order-lable">Team Member</label>
                <label className="col-sm-6 order-field">{orderData?.team_member}</label>
              </div> }
               
            </div>
            <div className="col-sm-3">
              <div className="form-group">
                <label className="d-block order-lable">Order Date / วันที่สั่ง</label>
                <label className="d-block order-field">{formatDate(orderData?.order_date)}</label>
              </div>
              <div className="m-b-0">
                <label className="d-block order-lable">Delivery Date / วันที่ส่ง</label>
                <label className="d-block order-field">{formatDate(orderData?.delivery_date)}</label>
              </div>
              <div className="m-b-0">
                <label className="d-block order-lable">Delivery Location</label>
                <label className="d-block order-field">{orderData?.location}</label>
              </div>
               <div className="m-b-0">
                <label className="d-block order-lable">Delivery Time</label>
                <label className="d-block order-field">{orderData?.delivery_priority}</label>
              </div>
            </div>
          </div>
        </div>

        <div className="border-blk p-0">
          <label className="order-lable remarks-text m-r-30" style={{wordWrap:"break-word"}}>Remarks: {item?.remarks || ""} </label>
          {/* <label className="value">{item?.remarks || ""}</label> */}
        </div>

        <div className="row-review print">
          <div className="col-8 p-0">
           <div className="row-review flex-wrap">{renderStylesData(parsedStyles, item.description)} 
            </div>
            <div className="row-review"><div className="col-review d-flex justify-center align-center p-0"><p className="title style-remarks">Style Remarks | หมายเหตุเกี่ยวกับสไตล์ : </p><p className="order" style={{marginLeft:'5px'}}>{parsedStyles?.remarks || ""}</p></div>
            </div>
          </div>
          <div className="col-4 p-2 border-blk measurements-info">
            <label className="title-measurement">
              {item?.componentType || item?.description} Measurement
            </label>
            {renderMeasurementsData(item?.measurements || {}, item.description)}
          </div>
        </div>

        {item?.images && item?.images.length > 0 && (
          <div className="canva_row break-page">
            <div className="row-image print">
              {item?.images.map((image, imageKey) => {
                const url = typeof image === "object" ? image.imagePath : image;
                return (
                  <div className="col-image" key={imageKey}>
                    <img
                      src={formatImageUrl(url)}
                      alt="Product Image"
                    />
                  </div>
                );
              })}
            </div>
          </div>
        )}

      </div>
    );
  }


  useEffect(() => {
    if (order_id) {
      fetchOrdrDetails();
    }
  }, [order_id]);



  return (
    <Layout>
      {isLoading && (
        <div className="loader_outer">
          <ClipLoader color="#123abc" size={80} />
        </div>
      )}

      <header className="header">
        <h1>Edit Invoice</h1>
        <p>
          <Link to="/" className="home-link">
            {" "}
            <HomeIcon />{" "}
          </Link>{" "}
          / Customers / Edit Invoice
        </p>
      </header>

      <div className="invoice_outer">
        <div className="invoce_outer_btns">
          <button onClick={handleEmail} className="btn">
            Email
          </button>
          <button onClick={handleGeneratePDF} classNameName="btn">
            PDF
          </button>
          <button onClick={handleEditPDF} classNameName="btn">
            Edit
          </button>
        </div>

        <div id="previewInvoice">
          {orderProducts.length > 0 &&
            orderProducts?.flatMap((item, key) => {
              // CASE 1: Suit → break into jacket and pant
              if (item.description === "Suit" && item.components) {
                const componentsToRender = [];

                if (item.components.jacket) {
                  componentsToRender.push({
                    ...item,
                    ...item.components.jacket, 
                    componentType: "Jacket",
                  });
                }

                if (item.components.pant) {
                  componentsToRender.push({
                    ...item, 
                    ...item.components.pant, 
                    componentType: "Pant",
                  });
                }

                return componentsToRender.map((component, index) =>
                  renderProductBlock(component, `${key}-${index}`)
                );
              }

              // CASE 2: Normal product (e.g. Shirt)
              return renderProductBlock(item, key);
            })}
        </div>
      </div>

    </Layout>
  );
};

export default OrderPreview;
